import React from 'react';

const FooterLogo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 450 450"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: 1.41421 }}
        {...props}
    >
        <path d="M323.481,78.625c0.57,0 1.097,0.19 1.519,0.51l0,-0.51c0,0 64.222,66.532 89.539,92.76c5.826,6.035 6.452,15.391 1.484,22.149c-10.121,13.765 -26.9,36.587 -37.628,51.179c-6.722,9.143 -12.707,18.806 -17.897,28.897c-8.07,15.689 -20.565,39.983 -28.376,55.169c-0.796,1.547 -2.548,2.349 -4.239,1.939c-1.692,-0.409 -2.883,-1.923 -2.883,-3.664c0,0 0,-204.967 0,-227.55c0,-0.4 -0.16,-0.783 -0.443,-1.065c-0.283,-0.282 -0.666,-0.44 -1.066,-0.438c-0.003,-0.001 -0.006,-0.001 -0.01,-0.001l-196.337,0c0,0 -0.001,0 -0.001,0c-0.402,0 -0.789,0.16 -1.073,0.445c-0.285,0.284 -0.445,0.67 -0.445,1.073c0,22.656 0,227.536 0,227.536c0,1.741 -1.191,3.255 -2.883,3.664c-1.691,0.41 -3.443,-0.392 -4.239,-1.939c-7.811,-15.186 -20.306,-39.48 -28.376,-55.169c-5.19,-10.091 -11.175,-19.754 -17.897,-28.897c-10.728,-14.592 -27.507,-37.414 -37.628,-51.179c-4.968,-6.758 -4.342,-16.114 1.484,-22.149c25.317,-26.228 89.539,-92.76 89.539,-92.76l0,0.51c0.422,-0.32 0.948,-0.51 1.519,-0.51l196.337,0Z" />
    </svg>
);

export default FooterLogo;
